'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _debounce2 = require('lodash/debounce');

var _debounce3 = _interopRequireDefault(_debounce2);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _class3, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrapTypeahead = require('react-bootstrap-typeahead');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _mobxReact = require('mobx-react');

var _mobx = require('mobx');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _ControlLabel = require('react-bootstrap/lib/ControlLabel');

var _ControlLabel2 = _interopRequireDefault(_ControlLabel);

var _FormGroup = require('react-bootstrap/lib/FormGroup');

var _FormGroup2 = _interopRequireDefault(_FormGroup);

var _HelpBlock = require('react-bootstrap/lib/HelpBlock');

var _HelpBlock2 = _interopRequireDefault(_HelpBlock);

var _constants = require('../../constants');

var _containers = require('../../containers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var DEBOUNCE_DELAY = _constants.AppConstants.DEBOUNCE_DELAY;

var Typeahead = (0, _containers.createInputContainer)(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_class2 = (_temp2 = _class3 = function (_Component) {
  _inherits(Typeahead, _Component);

  function Typeahead() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Typeahead);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Typeahead.__proto__ || Object.getPrototypeOf(Typeahead)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'value', _descriptor, _this), _initDefineProp(_this, 'onFocusValue', _descriptor2, _this), _initDefineProp(_this, 'inputValue', _descriptor3, _this), _initDefineProp(_this, 'isFocused', _descriptor4, _this), _this.isClearingInput = false, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Typeahead, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.setValueFromProps(this.props);

      if (this.props.onInputChange) {
        this.debouncedOnInputChange = (0, _debounce3.default)(this.props.onInputChange, DEBOUNCE_DELAY);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setValueFromProps(nextProps);
    }
  }, {
    key: 'setValueFromProps',
    value: function setValueFromProps(props) {
      if (typeof props.value !== 'undefined') {
        this.value = this.getCleanedValue([props.value]);
      }
    }
  }, {
    key: 'getCleanedValue',
    value: function getCleanedValue(value) {
      if (value.length > 0) {
        return value[0];
      }
    }

    // Both self-clear sites go through here, so onInputChange can tell the component emptying
    // the input from the user doing it. This relies on react-bootstrap-typeahead 1.4.2 calling
    // onInputChange synchronously inside clear(); the Typeahead focus test is what pins that.

  }, {
    key: 'clearInput',
    value: function clearInput() {
      this.isClearingInput = true;

      try {
        this.refTypeahead.getInstance().clear();
      } finally {
        this.isClearingInput = false;
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(value) {
      var _props = this.props,
          onChange = _props.onChange,
          setValue = _props.setValue,
          cleanValue = this.getCleanedValue(value),
          selectedAddNew = cleanValue && cleanValue.customOption;


      if (value.length === 1 && value[0].clear) {
        this.onFocusValue = null;
        this.clearInput();
        return;
      }

      // remove auto-id set by react-bootstrap-typeahead
      /* istanbul ignore next */
      if (selectedAddNew) {
        cleanValue.id = null;
      }

      this.value = cleanValue;

      // Formsy validation expects undefined but value coming back from typehead is an empty array when not selected
      setValue(cleanValue);
      onChange && onChange(cleanValue);
    }
  }, {
    key: 'onClick',
    value: function onClick(e) {
      if (e.target.className.includes('bootstrap-typeahead-input-main') || e.target.className.includes('control-label')) {
        this.refTypeahead.getInstance().focus();
      }
    }
  }, {
    key: 'onFocus',
    value: function onFocus(e) {
      this.isFocused = true;

      if (!this.props.clearOnFocus) {
        return;
      }

      this.onFocusValue = this.value;

      this.clearInput();

      this.onChange([]);

      // set the form input value to the previously cleared value
      this.props.setValue(this.getCleanedValue([this.value]));
    }
  }, {
    key: 'onBlur',
    value: function onBlur() {
      var _props2 = this.props,
          clearOnFocus = _props2.clearOnFocus,
          optionsLabelKey = _props2.optionsLabelKey,
          setValue = _props2.setValue;


      this.isFocused = false;

      if (!clearOnFocus) {
        return;
      }

      var valueSet = this.value && (0, _get3.default)(this.value, optionsLabelKey) !== '';

      if (!valueSet && this.onFocusValue) {
        this.value = this.onFocusValue;
        this.onInputChange((0, _get3.default)(this.onFocusValue, optionsLabelKey));

        // set the form input value to the previously cleared value
        setValue(this.getCleanedValue([this.value]));
      } else {
        this.refTypeahead.getInstance()._handleActiveItemChange(this.value);
      }
    }
  }, {
    key: 'checkHasValue',
    value: function checkHasValue() {
      var optionsLabelKey = this.props.optionsLabelKey;

      var valueSet = this.value && (0, _get3.default)(this.value, optionsLabelKey) !== '';
      return valueSet || this.onFocusValue || this.inputValue;
    }
  }, {
    key: 'onInputChange',
    value: function onInputChange(value) {
      var _props3 = this.props,
          onClear = _props3.onClear,
          onInputChange = _props3.onInputChange,
          minLength = _props3.minLength;

      // Emptying the input is swallowed by the guard below, so consumers that need to react to it
      // — to clear results that would otherwise outlive their query — get told separately.

      if (value === '') {
        // A search queued by the previous keystroke would otherwise still fire, and repopulate
        // results for a query the user has already erased.
        this.debouncedOnInputChange && this.debouncedOnInputChange.cancel();

        if (!this.isClearingInput) {
          onClear && onClear();
        }
        return;
      }

      if (!value || value.length < minLength) {
        return;
      }

      this.inputValue = value;
      this.onFocusValue = value;

      onInputChange && this.debouncedOnInputChange(value);
    }
  }, {
    key: '_fuzzySearchFilterBy',
    value: function _fuzzySearchFilterBy(option, text) {
      return option;
    }
  }, {
    key: 'filterBy',
    value: function filterBy() {
      var _props4 = this.props,
          filterBy = _props4.filterBy,
          fuzzySearch = _props4.fuzzySearch,
          optionsLabelKey = _props4.optionsLabelKey;


      if (fuzzySearch) {
        return this._fuzzySearchFilterBy;
      }

      return filterBy ? filterBy : [optionsLabelKey];
    }
  }, {
    key: 'setRefTypeahead',
    value: function setRefTypeahead(comp) {
      this.refTypeahead = comp;
    }
  }, {
    key: 'renderItem',
    value: function renderItem(option, props, idx) {
      var _props5 = this.props,
          renderItem = _props5.renderItem,
          optionsLabelKey = _props5.optionsLabelKey;


      if (option && option.clear) {
        return _react2.default.createElement(
          'div',
          { className: 'dropdown-menu-item dropdown-menu-item-clear' },
          (0, _get3.default)(option, optionsLabelKey)
        );
      } else if (renderItem) {
        // defer to parent if render method was provided
        return renderItem(option, props, idx);
      }

      // render default
      return _react2.default.createElement(
        'div',
        { className: 'dropdown-menu-item' },
        (0, _get3.default)(option, optionsLabelKey)
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props6 = this.props,
          clearText = _props6.clearText,
          controlId = _props6.controlId,
          errorMessage = _props6.errorMessage,
          formGroupId = _props6.formGroupId,
          isDisabled = _props6.isDisabled,
          label = _props6.label,
          options = _props6.options,
          optionsLabelKey = _props6.optionsLabelKey,
          placeholder = _props6.placeholder,
          required = _props6.required,
          search = _props6.search,
          showErrorMessage = _props6.showErrorMessage,
          showRequiredMessage = _props6.showRequiredMessage,
          validationState = _props6.validationState,
          className = (0, _classnames2.default)({ disabled: isDisabled }, 'form-group-typeahead', { 'has-value': this.checkHasValue() }, { 'focused': !!this.isFocused });


      var clearOrEmpty = [];
      if (clearText) {
        clearOrEmpty = [{ clear: true }];
        clearOrEmpty[0][optionsLabelKey] = clearText;
      }

      return _react2.default.createElement(
        _FormGroup2.default,
        {
          id: formGroupId, controlId: controlId,
          className: className,
          onClick: this.onClick,
          validationState: validationState },
        label && _react2.default.createElement(
          _ControlLabel2.default,
          null,
          label,
          required && _react2.default.createElement(
            'span',
            { className: 'required' },
            '*'
          )
        ),
        _react2.default.createElement(_reactBootstrapTypeahead.Typeahead, _extends({}, this.props, {
          disabled: isDisabled,
          filterBy: this.filterBy(),
          formNoValidation: true,
          labelKey: optionsLabelKey,
          onBlur: this.onBlur,
          onChange: this.onChange,
          onFocus: this.onFocus,
          onInputChange: this.onInputChange,
          options: clearOrEmpty.concat(options),
          placeholder: !search && this.onFocusValue ? (0, _get3.default)(this.onFocusValue, optionsLabelKey) : placeholder,
          ref: this.setRefTypeahead,
          renderMenuItemChildren: this.renderItem,
          selected: [this.value]
        })),
        showRequiredMessage && _react2.default.createElement(
          _HelpBlock2.default,
          null,
          label || 'This field',
          ' is required.'
        ),
        showErrorMessage && _react2.default.createElement(
          _HelpBlock2.default,
          null,
          errorMessage
        )
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return Typeahead;
}(_react.Component), _class3.defaultProps = {
  allowNew: false,
  clearOnFocus: true,
  disabled: false,
  emptyLabel: 'No results found.',
  fuzzySearch: false,
  minLength: 0,
  newSelectionPrefix: '+ Add ',
  options: [],
  optionsLabelKey: 'name',
  placeholder: '',
  required: false
}, _class3.propTypes = _extends({}, _containers.inputContainerProps, {
  allowNew: _propTypes2.default.bool,
  clearOnFocus: _propTypes2.default.bool,
  clearText: _propTypes2.default.string,
  emptyLabel: _propTypes2.default.string,
  filterBy: _propTypes2.default.arrayOf(_propTypes2.default.string),
  fuzzySearch: _propTypes2.default.bool,
  icon: _propTypes2.default.string,
  id: _propTypes2.default.string,
  label: _propTypes2.default.string,
  minLength: _propTypes2.default.number,
  name: _propTypes2.default.string.isRequired,
  newSelectionPrefix: _propTypes2.default.string,
  onChange: _propTypes2.default.func,
  onClear: _propTypes2.default.func,
  onInputChange: _propTypes2.default.func,
  options: _propTypes2.default.arrayOf(_propTypes2.default.object),
  optionsLabelKey: _propTypes2.default.string,
  placeholder: _propTypes2.default.string,
  renderItem: _propTypes2.default.func,
  renderMenu: _propTypes2.default.func,
  required: _propTypes2.default.bool,
  search: _propTypes2.default.bool
}), _temp2), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'value', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'onFocusValue', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, 'inputValue', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, 'isFocused', [_mobx.observable], {
  enumerable: true,
  initializer: null
})), _class2)) || _class) || _class) || _class;

var _default = Typeahead;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(DEBOUNCE_DELAY, 'DEBOUNCE_DELAY', '/app/src/components/common-formsy/Typeahead.js');
  reactHotLoader.register(Typeahead, 'Typeahead', '/app/src/components/common-formsy/Typeahead.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/common-formsy/Typeahead.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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